import OptOutPerPerson from "../../../../contents/docs/product-analytics/_snippets/multilanguage/opt-out-per-person.mdx";
import OptIn from "../../../../contents/docs/product-analytics/_snippets/multilanguage/opt-in.mdx";
import CheckOptOut from "../../../../contents/docs/product-analytics/_snippets/multilanguage/check-opt-out.mdx";
import OptOutDefault from "../../../../contents/docs/product-analytics/_snippets/multilanguage/opt-out-default.mdx";
import Tab from "components/Tab";
import AutocaptureWeb from "../../../../contents/docs/privacy/_snippets/autocapture-web.mdx";
import AutocaptureIOS from "../../../../contents/docs/privacy/_snippets/autocapture-ios.mdx";
import AutocaptureReactNative from "../../../../contents/docs/privacy/_snippets/autocapture-react-native.mdx";
import MaskingProductAnalytics from "../../../../contents/docs/privacy/_snippets/masking-product-analytics.mdx";
import { CalloutBox } from 'components/Docs/CalloutBox';
import IdentifyFrontendCode from "../../../../contents/docs/_snippets/identify-frontend-code.mdx";
import * as React from 'react';
export default {
  OptOutPerPerson,
  OptIn,
  CheckOptOut,
  OptOutDefault,
  Tab,
  AutocaptureWeb,
  AutocaptureIOS,
  AutocaptureReactNative,
  MaskingProductAnalytics,
  CalloutBox,
  IdentifyFrontendCode,
  React
};